const ReceptorInvoice = {
    PATIENT: 'PATIENT',
    COMPANY: 'COMPANY',
    GENERAL_PUBLIC: 'GENERAL_PUBLIC'
};

export default ReceptorInvoice;